$(function () {
  const $shareButtons = $('.share-buttons');
  if ($shareButtons.length <= 0)
    return false;

  const $copy = $shareButtons.find('.copy');
  if ($copy.length > 0) {
    const link = $copy.data('copy-link') ? $copy.data('copy-link') : '';
    const $copyIcon = $copy.find('.copy__icon');
    const $copySuccess = $copy.find('.copy__success');

    if ($copyIcon.length > 0) {
      $copyIcon.on('click', function () {
        navigator.clipboard.writeText(link);

        if ($copySuccess.length > 0) {
          $copySuccess.addClass('show');
          setTimeout(() => {
            $copySuccess.removeClass('show');
          }, 2000);
        }
      });
    }
  }
});
